module.exports = __webpack_public_path__ + "img/preview-1.b9de5d6b.webp";